import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../../../../config/firebase";

export const useForgotPasswordInfrastructure = () => {
    const sendResetEmail = async (email: string) => {
        try {
            await sendPasswordResetEmail(auth, email);
            return {
                success: true,
                message: 'Se ha enviado un correo de recuperación.'
            };
        } catch (error: any) {
            let errorMessage = 'Ocurrió un error al enviar el correo.';
            if (error.code === 'auth/user-not-found') {
                errorMessage = 'No existe una cuenta con este correo electrónico.';
            } else if (error.code === 'auth/invalid-email') {
                errorMessage = 'El correo electrónico no es válido.';
            }
            throw new Error(errorMessage);
        }
    };

    return {
        sendResetEmail
    };
};
